export default __webpack_public_path__ + "static/media/slayer-icon-bw.98af66dc.svg";